import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, TipoResponsableIva, SaveTipoResponsableIvaDto, SearchTipoResponsableIvaRequest } from "../model/index";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})
export class TipoResponsableIvaService extends CrudService<TipoResponsableIva, number, SaveTipoResponsableIvaDto, SearchTipoResponsableIvaRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'tipoResponsableIva', sharedFunctions);

  }
}